import React from "react";
import Contact from "../../Components/LandingPage/Components/Contact";
import PaymentGateway from "./PaymentGateway";

export default function Parent() {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      {/* Courses Section */}
      <main className="flex-grow">
        <PaymentGateway />
      </main>

      {/* Contact / Footer */}
      <footer className="w-full bg-gray-100 border-t">
        <Contact />
      </footer>
    </div>
  );
}
